import React, { useState } from "react";
import {
  ProfileSearchBarContainer,
  ProfileSearchBarElements,
  ProfileBar,
  PopoverContainer,
  CustomCheckbox,
} from "./SearchBarProfile.styles";
import { Popover, List, ListItem, ListItemText } from "@mui/material";
import TuneIcon from "@mui/icons-material/Tune";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckIcon from "@mui/icons-material/Check";
import CreatePostModal from "../../../components/common/CreatePostModal/CreatePostModal";

interface SearchBarProfileProps {
  onSearch: (text: string) => void;
  onFilterChange: (newFilter: string) => void;
  ownProfile: boolean;
}
const SearchBarProfile: React.FC<SearchBarProfileProps> = ({
  onSearch,
  onFilterChange,
  ownProfile
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const [selectedFilter, setSelectedFilter] = useState<string>("");
  const [selectedDateOption, setSelectedDateOption] = useState<string>("");
  const [searchText, setSearchText] = useState<string>("");
  const [isCreatePostOpen, setIsCreatePostOpen] = useState(false);

  const handleFilterOpen = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget as HTMLDivElement);
  };

  const handleFilterClose = () => {
    setAnchorEl(null);
    onFilterChange(selectedFilter);
  };

  const handleFilterChange = (value: string) => {
    if (selectedFilter === value) {
      setSelectedFilter("");
      setSelectedDateOption("");
    } else {
      setSelectedFilter(value);
      if (value !== "date") {
        setSelectedDateOption("");
      }
    }
  };

  const handleDateOptionChange = (value: string) => {
    if (selectedDateOption === value) {
      setSelectedDateOption("");
    } else {
      setSelectedDateOption(value);
    }
  };

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const text = event.target.value;
    setSearchText(text);
    onSearch(text);
  };

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;

  return (
    <ProfileSearchBarContainer>
      <ProfileSearchBarElements>
        <ProfileBar
          placeholder="Search"
          value={searchText}
          onChange={handleSearchInputChange}
        />
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <div onClick={handleFilterOpen} style={{ cursor: "pointer" }}>
            <TuneIcon />
          </div>
          {ownProfile &&
          (<div
            onClick={() => setIsCreatePostOpen(true)}
            style={{ cursor: "pointer" }}
          >
            <AddCircleOutlineIcon style={{ color: "#fe2f67" }} />
          </div>)
          }
        </div>

        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleFilterClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
        >
          <PopoverContainer>
            <List>
              <h3>Sort by</h3>
              {["Most Liked", "Most Recent", "date"].map((option) => (
                <ListItem
                  button
                  key={option}
                  onClick={() => handleFilterChange(option)}
                  selected={selectedFilter === option}
                  sx={{
                    "&:hover": {
                      backgroundColor:
                        selectedFilter !== option ? "#ffcad8" : "transparent",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "transparent !important",
                      boxShadow: "none",
                    },
                  }}
                >
                  <ListItemText primary={option === "date" ? "Date" : option} />
                  {selectedFilter === option && (
                    <CheckIcon style={{ color: "#fe2f67", fontSize: "16px" }} />
                  )}
                </ListItem>
              ))}
            </List>

            <List
              component="div"
              disablePadding
              style={{ marginTop: "-10px", marginLeft: "2px" }}
            >
              {["This week", "This month", "This year"].map((dateOption) => (
                <ListItem
                  button
                  key={dateOption}
                  onClick={() => handleDateOptionChange(dateOption)}
                  disabled={selectedFilter !== "date"}
                  style={{
                    opacity: selectedFilter === "date" ? 1 : 0.7,
                    cursor:
                      selectedFilter === "date" ? "pointer" : "not-allowed",
                  }}
                  sx={{
                    "&:hover": {
                      backgroundColor:
                        selectedFilter === "date" ? "#ffcad8" : "inherit",
                    },
                    "&.Mui-selected": {
                      backgroundColor: "transparent !important",
                      boxShadow: "none",
                    },
                  }}
                >
                  <CustomCheckbox checked={selectedDateOption === dateOption} />
                  <ListItemText primary={dateOption} />
                </ListItem>
              ))}
            </List>
          </PopoverContainer>
        </Popover>

        <CreatePostModal
          open={isCreatePostOpen}
          onClose={() => setIsCreatePostOpen(false)}
        />
      </ProfileSearchBarElements>
    </ProfileSearchBarContainer>
  );
};

export default SearchBarProfile;
